import React from 'react';
import AntdProForm, { ProFormSelect } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import { useQuery, gql } from '@apollo/client';
import ProForm from '../../layout/ProForm';
export const GET_APPROVAL_ROUTE_TEMPLATES = gql`
  query ApprovalRouteTemplates($ids: [ID!], $state: State) {
    approvalRouteTemplates(ids: $ids, state: $state) {
      id
      name
    }
  }
`;

const ApprovalRouteForm = ({ onFinish, initialValues }) => {
  const [form] = AntdProForm.useForm();
  const { data, loading } = useQuery(GET_APPROVAL_ROUTE_TEMPLATES, {
    variables: {
      state: 'ACTIVE',
    },
  });

  return (
    !loading && (
      <ProForm
        form={form}
        onFinish={onFinish}
        initialValues={initialValues}
        backPage="/system-setting/project-categories"
      >
        <ProFormSelect
          label="Virement"
          name="virement"
          key="virement"
          width="xl"
          placeholder="select"
          valueEnum={
            data
              ? data.approvalRouteTemplates.reduce((acc, { id, name }) => {
                  acc[id] = name;
                  return acc;
                }, {})
              : {}
          }
          rules={[
            {
              required: true,
              message: 'please select',
            },
          ]}
        />
        <ProFormSelect
          label="Extension"
          name="extension"
          key="extension"
          width="xl"
          placeholder="select"
          valueEnum={
            data
              ? data.approvalRouteTemplates.reduce((acc, { id, name }) => {
                  acc[id] = name;
                  return acc;
                }, {})
              : {}
          }
          rules={[
            {
              required: true,
              message: 'please select',
            },
          ]}
        />
        <ProFormSelect
          label="Extension Beyond Deadline Of Using Up Funding"
          name="extensionBeyondDeadlineOfUsingUpFunding"
          key="extensionBeyondDeadlineOfUsingUpFunding"
          width="xl"
          placeholder="select"
          valueEnum={
            data
              ? data.approvalRouteTemplates.reduce((acc, { id, name }) => {
                  acc[id] = name;
                  return acc;
                }, {})
              : {}
          }
          rules={[
            {
              required: true,
              message: 'please select',
            },
          ]}
        />
        <ProFormSelect
          label="Proposal Revision"
          name="proposalRevision"
          key="proposalRevision"
          width="xl"
          placeholder="select"
          valueEnum={
            data
              ? data.approvalRouteTemplates.reduce((acc, { id, name }) => {
                  acc[id] = name;
                  return acc;
                }, {})
              : {}
          }
          rules={[
            {
              required: true,
              message: 'please select',
            },
          ]}
        />
        <ProFormSelect
          label="Withdrawal"
          name="withdrawal"
          key="withdrawal"
          width="xl"
          placeholder="select"
          valueEnum={
            data
              ? data.approvalRouteTemplates.reduce((acc, { id, name }) => {
                  acc[id] = name;
                  return acc;
                }, {})
              : {}
          }
          rules={[
            {
              required: true,
              message: 'please select',
            },
          ]}
        />
      </ProForm>
    )
  );
};

ApprovalRouteForm.defaultProps = {
  initialValues: {},
};

ApprovalRouteForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default ApprovalRouteForm;
